import { useEffect, useState } from "react";
import SidebarCollapse from "../../../app/SidebarCollapse";
import RadioInput from "../../../general/RadioInput";
import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { EditableProps } from "../../editableProps";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import TextInput from "@builder/components/general/TextInput";
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";
import { useTranslation } from "react-i18next";

const Button: React.FC<EditableProps> = ({ parent, excluded }: EditableProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode);
    const [textType, setTextType] = useState<string>(!!selectedNode?.dynamicData ? "db" : "static");
    const { t } = useTranslation();

    const textTypeOptions = [
        {
            value: "static",
            img: "/static-text-icon.svg",
            checked: textType === "static",
            disabled: !!selectedNode?.dynamicData,
            tooltip: t("generalComponents.radioInput.Static")
        },
        { value: "db", img: "/db-icon.svg", checked: textType === "db", tooltip: t("generalComponents.radioInput.Dynamic") }
    ];

    const textTypeCallback = (value: string): void => {
        setTextType(value);
    };

    const staticTextCallback = (value: string): void => {
        dispatch(updateNodeProperty({ propertyPath: ["text"], value }));
    };

    useEffect(() => {
        if (selectedNode) {
            setTextType(!!selectedNode.dynamicData ? "db" : "static");
        }
    }, [selectedNode?.id]);

    if (excluded?.includes("dynamic")) {
        return (
            <SidebarCollapse title="Text" parent={parent}>
                <TextInput title="Input text" value={selectedNode?.text || ""} placeholder="Enter text" callback={staticTextCallback} />
            </SidebarCollapse>
        );
    } else {
        return (
            <SidebarCollapse title="Button" parent={parent}>
                <RadioInput groupName="textType" options={textTypeOptions} callback={textTypeCallback}></RadioInput>
                {textType === "static" ? (
                    <TextInput title="Input text" value={selectedNode?.text || ""} placeholder="Enter text" callback={staticTextCallback} />
                ) : (
                    <DynamicDataSelectorInput />
                )}
            </SidebarCollapse>
        );
    }
};

export default Button;
